<template>
    <div
        class  = "lm-border doc-entry mb-0 mr-1"
        style="position: relative"
        :class="border + ' ' + background(hover)"
        @click = "onDocument"
    >
        <p-dms-properties
            v-model       = "showProperties"
            :step-data-id = "stepDataId"
            :category     = "category"
            :document     = document
        />

        <p-dms-information
            v-model       = "showInformation"
            :information  = information
        />

        <p-dms-versions
            v-model       = "showVersions"
            :step-data-id = "stepDataId"
            :document     = document
        />

        <p-dms-combine
            v-model       = "showCombine"
            :step-data-id = "stepDataId"
        />

        <p-dms-move
            v-model       = "showMove"
            :step-data-id = "stepDataId"
            :document     = "document"
        />

        <d-dms-stamper
            v-if     = "showStamper"
            ref      = "stamper"
            :stamp   = "stampCategory"
            @stamped = "onStamped"
            @closed  = "onStamperClosed"
        />


        <div style="display: block; " class="pl-2 doc-col" >
            <div class="doc-info v-flex">
                <c-inc-document-icon
                    class="pr-0"
                    style="margin-top: -5px; max-height: 20px; margin-right: 2px;"
                    :document = "document"
                    :size = "22"
                    :color="hover ? 'white primary--text' : 'primary white--text'"
                />

                <!-- unit chip -->
                <div v-if="document.unitName" class="doc-unit mr-1" :class="hover ? 'white primary--text' : 'primary white--text'">
                    {{ document.unitName }}
                </div>
                <!-- unit chip -->

                <!-- bid chip -->
                <div v-if="document.bidId && !compact" class="doc-unit mr-1" :class="hover ? 'white--text' : 'primary--text'">
                    {{ bidname }}
                </div>
                <!-- bid chip -->

                <!-- document type -->
                <div>
                    {{ document.type ? document.type.name : '---'}}
                </div>
                <!-- document type -->


                <div
                    v-if  = "allowQuickChange"
                    class = "quick-change-toolbar v-flex"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if = "isInvoice">
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.RG)"
                                elevation="0"
                                x-small
                            >
                                RG
                            </v-btn>
                        </template>
                        <span>Rechnung</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if = "isInvoice">
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary lighten-2 white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.MAH)"
                                elevation="0"
                                x-small
                            >
                                MAH
                            </v-btn>
                        </template>
                        <span>Rechnung</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if = "isInvoice">
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary lighten-4 white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.ST)"
                                elevation="0"
                                x-small
                            >
                                ST
                            </v-btn>
                        </template>
                        <span>Stornobeleg</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if = "isMaintenance">
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.WB)"
                                elevation="0"
                                x-small
                            >
                                WB
                            </v-btn>
                        </template>
                        <span>Wartungsbericht</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if = "isAssessment">
                            <v-btn
                                v-bind      = "attrs"
                                v-on        = "on"
                                :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                class       = "quick-change-button"
                                @click.stop = "onQuickChange(doctype.PB)"
                                elevation="0"
                                x-small
                            >
                                PB
                            </v-btn>
                        </template>
                        <span>Prüfbericht</span>
                    </v-tooltip>

                    <div v-if = "isRepair">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }" >
                                <v-btn
                                    v-bind      = "attrs"
                                    v-on        = "on"
                                    :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                    class       = "quick-change-button"
                                    @click.stop = "onQuickChange(doctype.AS)"
                                    elevation="0"
                                    x-small
                                >
                                    AS
                                </v-btn>
                            </template>
                            <span>Arbeitsschein</span>
                        </v-tooltip>
                    </div>

                    <div v-if = "isRepair">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }" >
                                <v-btn
                                    v-bind      = "attrs"
                                    v-on        = "on"
                                    :color      = "hover ? 'white primary--text' : 'primary  lighten-2  white--text'"
                                    class       = "quick-change-button"
                                    @click.stop = "onQuickChange(doctype.ANG)"
                                    elevation="0"
                                    x-small
                                >
                                    ANG
                                </v-btn>
                            </template>
                            <span>Angebot</span>
                        </v-tooltip>
                    </div>

                    <div v-if = "isRepair">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }" >
                                <v-btn
                                    v-bind      = "attrs"
                                    v-on        = "on"
                                    :color      = "hover ? 'white primary--text' : 'primary lighten-4  white--text'"
                                    class       = "quick-change-button"
                                    @click.stop = "onQuickChange(doctype.AUF)"
                                    x-small
                                    elevation="0"
                                >
                                    AUF
                                </v-btn>
                            </template>
                            <span>Aufträge</span>
                        </v-tooltip>
                    </div>

                    <div>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }" v-if = "isIncident">
                                <v-btn
                                    v-bind      = "attrs"
                                    v-on        = "on"
                                    :color      = "hover ? 'white primary--text' : 'primary white--text'"
                                    class       = "quick-change-button"
                                    @click.stop = "onQuickChange(doctype.AS)"
                                    x-small
                                >
                                    AS
                                </v-btn>
                            </template>
                            <span>Arbeitsschein</span>
                        </v-tooltip>
                    </div>
                </div>
                <v-spacer />
            </div>

            <div class="doc-subinfo" :class="compact ? 'doc-filename-compact' : 'doc-filename'">
                {{ document.name }}
            </div>
        </div>

        <v-spacer />

        <div style="display: block" class="doc-col">
            <div class="doc-date pr-2">
                {{ timeAsString(document.createdDate) }}
            </div>
            <div class="doc-subinfo">
                {{ document.createdBy }}
            </div>
        </div>

        <div style="padding-top: 12px;" >
            <input
                type         = "file"
                style        = "display:none"
                :accept      = "extensions"
                ref          = "uploadButton"
                @click.stop  = "onFileClick"
                @change      = "onReplaceFile"
            />
            <v-menu
                v-model = "menu"
                offset-x
            >
                <template v-slot:activator="{ props }">
                    <a
                        @click.stop = "onMenu"
                        v-bind="props"
                        style="margin-top: -5px"
                    >
                        <v-icon size="24" :color = "hover || menu ? 'white' : ''">mdi-dots-vertical</v-icon>
                    </a>
                </template>

                <v-list style="width: 210px; font-size: 15px">
                    <v-list-item @click="onShowDocument">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <i class="fas fa-eye"></i>
                            </div>
                            <div>{{ $t("dms.entry.menu.show") }}</div>
                        </div>
                    </v-list-item>
                    <v-list-item @click="onFadeInDocument">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon class="ml-n1" size="22" color="black">mdi-open-in-new</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.fadein") }}</div>
                        </div>
                    </v-list-item>
                    <v-list-item @click="onDownload">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <i class="fas fa-download menu-icon"></i>
                            </div>
                            <div>{{ $t("dms.entry.menu.download") }}</div>
                        </div>
                    </v-list-item>

                    <v-divider class="mt-2 mb-2" />

                    <v-list-item @click="onInfo">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon class="ml-n1" size="22" color="black">mdi-information-outline</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.info") }}</div>
                        </div>
                    </v-list-item>
                    <v-list-item @click="onProperties">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon size="20" color="black">mdi-file-cog-outline</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.props") }}</div>
                        </div>
                    </v-list-item>
                    <v-list-item @click="onVersions" >
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon size="20" color="black">mdi-file-clock-outline</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.versions") }}</div>
                        </div>
                    </v-list-item>
                    <v-divider class="mt-2 mb-2" />
                    <v-list-item
                        @click="onConfirmDetach"
                        v-if="(!document.stamped && document.messageId) && document.typename !== 'Mail - gesendet' && !document.referenced"
                    >
                        <div class="v-flex">
                            <div class="menu-icon">
                                <i class="fas fa-unlink"></i>
                            </div>
                            <div>{{ $t("dms.entry.menu.detach") }}</div>
                        </div>
                    </v-list-item>
                    <v-list-item @click="onConfirmDelete" v-if="(!document.messageId || document.stamped)  && !document.referenced">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <i class="fas fa-trash-alt"></i>
                            </div>
                            <div>löschen</div>
                        </div>
                    </v-list-item>

                    <v-list-item @click="onReplace">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon size="20" color="black">mdi-file-replace-outline</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.replace") }}</div>
                        </div>
                    </v-list-item>

                    <v-list-item @click="onStamp">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon size="20" color="black">mdi-stamper</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.stamp") }}</div>
                        </div>
                    </v-list-item>

                    <v-list-item @click="onMove">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon size="20" color="black">mdi-file-move-outline</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.move") }}</div>
                        </div>
                    </v-list-item>

                    <v-divider class="mt-2 mb-2" />

                    <v-list-item @click="onCombine">
                        <div class="v-flex">
                            <div class="menu-icon">
                                <v-icon size="20" color="black">mdi-file-multiple</v-icon>
                            </div>
                            <div>{{ $t("dms.entry.menu.combine") }}</div>
                        </div>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </div>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import Dms              from "@/modules/dms/common/service/Dms";
import Inb              from "@/modules/inb/service/Inb";
import Inc              from "@/modules/inc/service/Inc";
import PDmsProperties   from "@/modules/dms/menu/components/private/PDmsProperties.vue";
import PDmsInformation  from "@/modules/dms/menu/components/private/PDmsInformation.vue";
import PDmsVersions     from "@/modules/dms/menu/components/private/PDmsVersions.vue";
import PDmsCombine      from "@/modules/dms/menu/components/private/PDmsCombine.vue";
import CIncDocumentIcon from "@/modules/dms/common/components/CIncDocumentIcon.vue";
import PDmsMove         from "@/modules/dms/menu/components/private/PDmsMove.vue";
import DDmsStamper from "@/modules/dms/stamp/components/DDmsStamper.vue";

export default {
    name: "PDmsEntry",

    components: {
        DDmsStamper,
        PDmsMove,
        CIncDocumentIcon,
        PDmsCombine,
        PDmsVersions,
        PDmsInformation,
        PDmsProperties
    },

    props: {
        stepDataId: {

        },

        category: {

        },

        document: {

        } ,

        hover: {

        },

        index: {

        },

        blockIndexes: {

        },

        compact: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        },
    },

    data: () => ({
        menu           : false,
        showProperties : false,
        showInformation: false,
        showVersions   : false,
        showCombine    : false,
        showMove       : false,
        showStamper    : false,
        information    : null,
        versions       : null,
        doctype: {
            RG: 3,
            WB: 4,
            PB: 2,
            AS: 10,
            ANG: 6,
            AUF: 9,
            MAH: 11,
            ST: 24
        }
    }),

    computed: {
        border () {
            switch (this.borderType (this.index)) {
                case"top":
                    return "top-border-radius";
                case"bottom":
                    return "bottom-border-radius";
                case "topbottom":
                    return "top-bottom-border-radius";
            }

            return "middle-border-radius";
        },

        clickMode () {
            return this.$store.getters.preferences.dmsdisplaymode;
        },

        bidname () {
            return this.$t("repair.bid.name." + this.document.bidName);
        },

        extensions () {
            const ext = this.document.name.slice((this.document.name.lastIndexOf(".") - 1 >>> 0) + 2);
            return "." + ext;
        },

        stampCategory () {
            if (this.category && this.category === 'repairService') {
                return "BID";
            }

            return "INVOICE";
        },

        isInvoice () {
            return this.category && this.category === 'invoiceService';
        },

        isRepair () {
            return this.category && this.category === 'repairService';
        },

        isIncident () {
            return this.category && this.category === 'issueService';
        },

        isAssessment () {
            return this.category && this.category === 'assessmentService';
        },

        isMaintenance () {
            return this.category && this.category === 'maintenanceService';
        },

        allowQuickChange () {
            console.log("allowQuickChange",  this.document && this.document.type && this.document.type.id === 0)
            return this.document && this.document.type && this.document.type.id === 0;
        }
    },

    methods: {
        background (hover) {
            if (this.menu) {
               return "background-selected";
            }

            return hover ? 'primary white--text' : ' black--text'
        },

        onMenu () {
            this.menu = !this.menu;
        },

        /**
         * Called when the user selects a document directly by clicking on it.
         */
        onDocument () {
            if (this.clickMode) {
                this.onFadeInDocument();
                this.$bus.$emit(this.$events.dms.fadein, this.document);
                return;
            }

            this.onShowDocument();
        },

        /**
         * Called when the user selects a document by the document's context menu.
         */
        onShowDocument () {
            Dms.open(this.document.id, this.document.name);
        },

        onFadeInDocument () {
            this.$bus.$emit(this.$events.dms.fadein, this.document);
        },

        /**
         * Called when the user selects the information button in the entry menu.
         */
        onInfo () {
            Dms.info(this.document.id).then (info => {
                this.showInformation = true;
                this.information = info;
            })
        },

        /**
         * Called when the user selects the download button in the entry menu.
         */
        onDownload () {
            Dms.download(this.document.id, (filename, data)  => {
                let link = document.createElement('a');
                link.href = data;
                link.download = filename ? filename : this.document.name;
                link.click()
            });
        },

        /**
         *
         */
        onConfirmDetach () {
            Core.message.confirm(
                this,
                this.$t("inc.confirm.document.detach.query"),
                this.$t("inc.confirm.document.detach.text"),
                Core.message.Default,
                () => {
                    Inb.detach(this, this.document.messageId).then (() => {
                        this.load();
                        this.$bus.$emit(Inb.event.refresh);
                        this.confirm = false;
                    });
                });
        },

        /**
         * Called when the user selects the delete button in the entry menu.
         */
        onConfirmDelete () {
            Core.message.confirm(
                this,
                this.$t("inc.confirm.document.delete.query"),
                this.$t("inc.confirm.document.delete.text"),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Inc.document.remove (this, this.document.id).then((data)=> {
                            this.$bus.$emit(Dms.event.document.refresh, {
                                id       : this.stepDataId,
                                documents: data
                            });
                        });

                        Core.message.hint(this,  this.$t("dms.entry.message.removed"));
                    }
                });
        },

        onProperties () {
            this.showProperties = true;
        },

        onReplace (e) {
            e.stopPropagation();
            this.$refs.uploadButton.click();
        },

        onStamp () {
            this.showStamper = true;
            this.$nextTick(() => {
                this.$refs.stamper.open (this.document);
            })
        },

        onStamperClosed () {
            this.showStamper = false;
        },

        onStamped () {
            Inc.document.byStep(this.stepDataId, {
                bidId : null,
                unitId: null,
            }, data => {
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data
                });
            });
        },

        onReplaceFile () {
            const files = this.$refs.uploadButton.files;
            Inc.document.replace(this, this.document.id, files[0]).then((data) => {
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data
                });
                Core.message.hint(this,  this.$t("dms.entry.message.replaced"));
            });
        },

        onMove () {
              this.showMove = true;
        },

        onFileClick () {

        },

        onSelected (value) {
            this.$emit("selected", {
                id      : this.document.id,
                selected: value
            });
        },

        onVersions () {
            this.showVersions = true;
        },

        onCombine () {
            this.showCombine = true;
        },

        onQuickChange (typeId) {
            Inc.document.setType(this, this.document.id, typeId).then((data) => {
                this.$bus.$emit(Dms.event.document.refresh, {
                    id       : this.stepDataId,
                    documents: data
                });
                Core.message.hint(this,  this.$t("dms.entry.message.type"));
            })
            .catch(() => {})
        },

        timeAsString (value) {
            return Core.format.datetime.display(value);
        },

        borderType (index) {
            if (index >= this.blockIndexes.length-1) {
                if (index > 0 && this.blockIndexes[index])  {
                    return "topbottom";
                }

                if (this.blockIndexes.length === 1) {
                    return "topbottom";
                }

                return "bottom";
            }

            const nextIndexStart = this.blockIndexes[index+1];
            if ( this.blockIndexes[index] && nextIndexStart) {
                return "topbottom"
            }

            if (this.blockIndexes[index]) {
                return "top";
            }

            if (nextIndexStart) {
                return "bottom";
            }

            return "middle";
        }
    }
}
</script>

<style scoped>

.doc-info {
    font-size: 14px;
    padding-top: 1px;
}

.doc-col {
    padding-top: 6px;
    padding-bottom: 3px;
}

.doc-date {
    font-size: 12px;
    margin-top: 4px;
}

.doc-subinfo {
    font-size: 11px;
    margin-top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.doc-filename {
    max-width: 330px;
    width: 330px;
}

.doc-filename-compact {
    max-width: 220px;
    width: 200px;
}

.doc-unit {
    font-size: 12px;
    padding-left: 8px;
    padding-right: 8px;
    height: 18px;
    margin-top: 2px;
    min-width: 80px;
    text-align: center;
    border-radius: 2px;
}

.menu-icon {
    width: 30px;
    min-width: 30px;
    text-align: left;
}

.quick-change-toolbar {
    margin-top: -1px;
    margin-left: 4px;
    border-radius: 4px;
    background-color: transparent!important;
}

.quick-change-button {
    font-weight: 500;
    font-size: 11px;
    padding-top: 2px!important;
    text-transform: none;
    letter-spacing: unset;
    width: 40px;
    margin-left: 4px;
}

.quick-change-button-single {
    font-weight: 500;
    font-size: 11px;
    padding-top: 2px!important;
    text-transform: none;
    letter-spacing: unset;
    width: 40px;
    margin-top: 14px;
}

.quick-change-button-left {
    position: absolute;
    font-weight: 500;
    font-size: 11px;
    padding-top: 2px!important;
    text-transform: none;
    letter-spacing: unset;
    width: 40px;
    margin-top: 2px;
    right: 44px;
}

.top-border-radius {
    border-radius: 8px 8px 0 0!important;
    border-bottom-style: none;
}

.bottom-border-radius {
    border-radius: 0 0 8px 8px!important;
    margin-top: -2px;
}

.top-bottom-border-radius {
    border-radius: 8px 8px 8px 8px!important;
}

.middle-border-radius {
    border-radius: 0 0 0 0!important;
    margin-top: 0px;
    border-bottom-style: none!important;
}

</style>